import Cookies from 'js-cookie'

const TokenKey = 'loginToken'
const ShopId = 'shopid'
const ShopName = 'shopname'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  //TODO 
  return Cookies.set(TokenKey, token,{expires: 30, path: '/'})
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getShopId() {
  return Cookies.get(ShopId)
}

export function getShopName() {
  return Cookies.get(ShopName)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js